export const LOCAL_STORAGE_NAME = "todos";
export const LOCAL_STORAGE_ID = "todosId";